import { useSelector } from 'react-redux'

import { getUserIdentity } from '~/redux-modules/identity'

interface Identity {
    flags?: Record<string, string>
}

export default function isFlagEnabled(
    identity: Identity,
    flag: string,
    value: string,
) {
    const { flags = {} } = identity

    return flags[flag] === value
}

export const useFlagEnabled = (flag: string) => {
    return useSelector(state =>
        isFlagEnabled(getUserIdentity(state), flag, 'true'),
    )
}
